import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import striptags from 'striptags';
import FCLink from '../fc_link/fc_link';

function processAssetServerImage(
  imgSrc,
  width = 387,
  height = 218,
  placeholder = 'https://assets.fastcompany.com/image/upload/w_387,h_218,c_fill,q_auto,f_auto,fl_lossy,o_30/v1498077352/fcweb/ibd_a2ubg2.jpg'
) {
  let updatedImgSrc = imgSrc;

  if (typeof imgSrc !== 'string' || imgSrc.length === 0) {
    updatedImgSrc = placeholder;
  }

  const sites = ['fastcompany', 'coexist', 'codesign', 'cocreate'];

  sites.forEach(function replaceSite(siteName) {
    updatedImgSrc = updatedImgSrc.replace(
      `multisite_files/${siteName}`,
      `multisite_files/${siteName}/imagecache/w/${width}/h/${height}/crop`
    );
  });
  return updatedImgSrc;
}

export default class IBDCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionOpen: false
    };
    this.scopedToggle = this.toggleAccordion.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.accordionOpen !== nextState.accordionOpen;
  }

  toggleAccordion() {
    this.setState({
      accordionOpen: !this.state.accordionOpen
    });
  }

  render() {
    const { category, index, year } = this.props;

    const categoryName = get(category, 'category_name');
    const judges = get(category, 'judges_people');
    const winners = get(category, 'products.winners');
    const finalists = get(category, 'products.finalists');
    const mentions = get(category, 'products.mentions', []);
    const productFieldToDisplay = year >= 2018 ? 'description' : 'why';

    return (
      <section
        className={`ibd-category ibd-category--${index} ${this.state
          .accordionOpen
          ? 'ibd-category--active'
          : ''}`}
      >
        <div
          onClick={this.scopedToggle}
          className={`ibd-category__row ibd-category__row--${index}`}
        >
          {' '}
          <div
            className={`ibd-category__header ${this.state.accordionOpen
              ? 'ibd-category__header--active'
              : ''}`}
          >
            <h2 className="ibd-category__title">{categoryName}</h2>
            <img
              className={`ibd-category__title-icon
              ${this.state.accordionOpen
                ? ' ibd-category__title-icon--active'
                : ''}`}
              src={
                '//assets.fastcompany.com/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg'
              }
              alt="arrow icon"
              title="arrow icon"
            />
          </div>
          {this.state.accordionOpen
            ? <div className={`ibd-category__dek`}>
                <div className="ibd-category__category-description">
                  {striptags(category.category_description || '')}
                </div>
                {judges.length
                  ? <div className="ibd-category__judges">
                      <span className="bold">Judges:</span>{' '}
                      {judges.map(judge => judge.name).join(', ')}
                    </div>
                  : ''}
              </div>
            : ''}
        </div>
        {this.state.accordionOpen
          ? <div
              className={`ibd-category__accordion ibd-category__accordion--${index}`}
            >

              <div className="ibd-category__accordion-section ibd-category__accordion-section--winners">
                <h3 className="ibd-category__accordion-section-title">
                  <span>Winners</span>
                </h3>
                {winners.map(winner =>
                  <FCLink
                    currentSite="fastcodesign"
                    to={`//www.fastcodesign.com/product/${winner.url}`}
                    key={winner.name}
                  >
                    <figure className="ibd-category__product-poster ibd-category__product-poster--winner">
                      <img
                        alt={winner.name}
                        src={processAssetServerImage(
                          get(winner, 'image'),
                          599,
                          337
                        )}
                      />
                    </figure>
                    <h4 className="ibd-category__product-name ibd-category__product-name--winner">
                      {winner.name}
                    </h4>
                    {winner[productFieldToDisplay]
                      ? <h4 className="ibd-category__product-description ibd-category__product-description--winner">

                          {striptags(winner[productFieldToDisplay])}
                        </h4>
                      : ''}
                    {winner.body
                      ? <div
                          className="ibd-category__credit"
                          dangerouslySetInnerHTML={{ __html: winner.body }}
                        />
                      : ''}
                  </FCLink>
                )}
              </div>

              <div className="ibd-category__accordion-section ibd-category__accordion-section--finalists">
                <h3 className="ibd-category__accordion-section-title">
                  <span>Finalists</span>
                </h3>
                {finalists.map(product =>
                  <FCLink
                    currentSite="fastcodesign"
                    to={`//www.fastcodesign.com/product/${product.url}`}
                    key={product.name}
                  >
                    <figure className="ibd-category__product-poster">
                      <img
                        alt={product.name}
                        src={processAssetServerImage(get(product, 'image'))}
                      />
                    </figure>
                    <h4 className="ibd-category__product-name">
                      {product.name}
                    </h4>
                    {product[productFieldToDisplay]
                      ? <h4 className="ibd-category__product-description">
                          {striptags(product[productFieldToDisplay])}
                        </h4>
                      : ''}

                    {product.body
                      ? <div
                          dangerouslySetInnerHTML={{ __html: product.body }}
                        />
                      : ''}
                  </FCLink>
                )}
              </div>

              {mentions.length
                ? <div className="ibd-category__accordion-section ibd-category__accordion-section--mentions">
                    <h3 className="ibd-category__accordion-section-title">
                      <span>Honorable Mentions</span>
                    </h3>
                    {mentions.map(product =>
                      <FCLink
                        currentSite="fastcodesign"
                        to={`//www.fastcodesign.com/product/${product.url}`}
                        key={product.name}
                      >
                        <figure className="ibd-category__product-poster">
                          <img
                            alt={product.name}
                            src={processAssetServerImage(get(product, 'image'))}
                          />
                        </figure>
                        <h4 className="ibd-category__product-name">
                          {product.name}
                        </h4>
                        {product[productFieldToDisplay]
                          ? <h4 className="ibd-category__product-descriptionw">
                              {striptags(product[productFieldToDisplay])}
                            </h4>
                          : ''}

                        {product.body
                          ? <div
                              dangerouslySetInnerHTML={{ __html: product.body }}
                            />
                          : ''}
                      </FCLink>
                    )}
                  </div>
                : ''}

            </div>
          : ''}
      </section>
    );
  }
}

IBDCategory.propTypes = {
  category: PropTypes.shape({}).isRequired,
  index: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/ibd_category/ibd_category.js